// extracted by mini-css-extract-plugin
module.exports = {"primary":"#f98c1b","secondary":"#0e0d0d"};